import { EnvBrandType } from '@grupoboticario/barril-del-chavo'
import {
  boticarioTheme,
  eudoraTheme,
  gbInstitucionalTheme,
  ouiTheme,
  quemDisseBereniceTheme,
} from '@grupoboticario/flora'

export enum BrandName {
  BOTICARIO = 'BOT',
  EUDORA = 'EUD',
  EU_AMO_MAKE = 'EAM',
  OUI = 'OUI',
  MULTIMARCAS = 'MLT',
}

export enum BrandNameText {
  BOT = 'O Boticário',
  EUD = 'Eudora',
  EAM = 'Eu Amo Make',
  OUI = 'O.U.I.',
  MLT = 'Grupo Boticário',
}

export const BrandTheme = {
  BOT: boticarioTheme,
  EUD: eudoraTheme,
  EAM: quemDisseBereniceTheme,
  OUI: ouiTheme,
  MLT: gbInstitucionalTheme,
}

export type TBrand = EnvBrandType
